import { variantsMapper } from './convert-to-style-properties';
export const updatePropertyObject = (properties, newProperties) => {
  const updated = {
    ...properties
  };
  Object.entries(newProperties).forEach(_ref => {
    let [field, value] = _ref;
    if (!value) {
      return;
    }
    const variant = variantsMapper[field].find(currentVariant => properties.hasOwnProperty(currentVariant)) || field;
    updated[variant] = value;
  });
  return updated;
};
//# sourceMappingURL=update-property-object.js.map